import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { isEqual } from 'lodash'
import { sortOpts } from '../../utils/utils'
import Form from '../ui/Form'

export default class PRSAddPmntForm extends Form {

  static propTypes = {
    editPost: PropTypes.func.isRequired,
    cancelAdd: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);
    this.state = {
      data: props.data,
      errors: {}
    };
  }

  savePost = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(this.props.data, data)) {
      this.props.cancelAdd();
    }
    else {
      this.props.editPost(data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.props.cancelAdd();
        const diff = data.post_price * data.post_qntt;
        if(this.props.orderPayment) {
          this.props.updtBlnc(0, diff, 0);
        }
        else {
          this.props.updtBlnc(0, 0, diff);
        }
      });
    }
  }

  updateSrvc = e => {
    this.setState({
      data:{
        ...this.state.data,
        post_srvc_id: e.value,
        post_desc: this.props.srvcs[e.value].srvc_desc
      }
    });
  }

  payedToday = () => {
    this.setState({
      data:{
        ...this.state.data,
        post_bdate: moment().format('Y-MM-DD'),
        post_payed: 1
      }
    });
  }

  render(){
    const { srvcs, costDesc } = this.props;

    const { data, errors } = this.state;

    var pmntsOpt = [];
    for (var key in srvcs){
    if(srvcs.hasOwnProperty(key)) {
      if(
        (
          srvcs[key].srvc_type === -1 &&
          srvcs[key].srvc_active === 1
        ) ||
        srvcs[key].srvc_id === data.post_srvc_id
      ){
        pmntsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
      }
    }
    }
    pmntsOpt.sort(sortOpts);

    return (
      <div
        className="modal"
        style={{
          paddingTop:'15%',
          overflowY:'visible',
          backgroundColor: 'rgba(30,30,30,.7)',
          display:'block'
        }}
      >
        <div
          className="modal-admin modal-m"
          style={{margin: 'auto', maxWidth: '90%'}}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 style={{margin:0}}>Добавить оплату для {costDesc}</h4>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-xs-4">
                  <div className="form-group">
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                      <label>Метод</label>&nbsp;
                      <div style={{flex: 1, width: 0}}>
                        <Select
                          clearable={false}
                          options={pmntsOpt}
                          value={data.post_srvc_id}
                          onChange={this.updateSrvc}
                          autofocus
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea type="text"
                      className="form-control"
                      name="post_desc"
                      value={data.post_desc}
                      rows="3"
                      title="Описание"
                      placeholder="Описание"
                      onChange={this.updateInput}
                    />
                  </div>
                </div>
                <div className="col-xs-1">
                  <input type="text"
                    className="form-control text-editable"
                    value={data.post_price}
                    name="post_price"
                    onChange={this.updateInput}
                  />
                </div>
                <div className="col-xs-3">
                  <div className="form-group">
                    <label style={{cursor:'pointer',fontWeight:(data.post_payed?'bold':'normal')}}>
                      Оплачено{" "}
                      <input type="checkbox" checked={data.post_payed}
                        name="post_payed" onChange={this.handleChBox} />
                    </label>{" "}
                    <span style={{cursor:'pointer',textDecoration:'underline'}}
                      onClick={this.payedToday}>Сегодня</span>
                  </div>
                  <div className="form-group">
                    <DatePicker
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      selected={moment(data.post_bdate)}
                      onChange={e => this.updateDate(e, 'post_bdate')}
                      title="Дата оплаты"
                    />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <textarea type="text"
                      className="form-control"
                      value={data.post_note}
                      rows="3"
                      placeholder="Заметка"
                      title="Заметка"
                      name="post_note"
                      onChange={this.updateInput}
                    />
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="btn btn-default"
                onClick={this.props.cancelAdd}
              >Отмена</button>{" "}
              <button
                type="button"
                className="btn btn-success"
                onClick={this.savePost}
              >Сохранить</button>
              {errors.form && <div className="alert alert-danger">{errors.form}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSAddPmntForm.js